import { DetailPage } from '../../components/DetailPage/DetailPage';

import { CallPreferencesSection } from './CallPreferencesSection/CallPreferences.section';
import { PhoneNumberSection } from './PhoneNumberSection/PhoneNumber.section';
import { SIPDevicesSection } from './SIPDevicesSection/SIPDevices.section';

import { useFeatures } from '@hooks/useFeatures/useFeatures';
import { UserProfileTabProps } from '@pages/user-profile/UserProfile.decl';

function UserProfileCallPreferences({ user }: UserProfileTabProps) {
  const { isSipSettingsAllowed } = useFeatures();

  return (
    <DetailPage>
      <CallPreferencesSection user={user} />
      <PhoneNumberSection user={user} />
      {isSipSettingsAllowed && <SIPDevicesSection user={user} />}
    </DetailPage>
  );
}

export default UserProfileCallPreferences;
